export const appleConfig = {
    clientId: '3303.ua',
    redirectURI:'https://storage.3303.ua/auth/callback/apple'
}
